 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chat":"chat","gf":"gf","admin":"admin","aliBey":"aliBey","habit~nutrition":"habit~nutrition","nutrition":"nutrition","HomeNew.vue":"HomeNew.vue","workouts":"workouts","dashboard":"dashboard","user":"user","einmalig":"einmalig","habit":"habit","social":"social","deviceManagement":"deviceManagement","event":"event","shop":"shop","friends":"friends","payment":"payment","redirection":"redirection"}[chunkId]||chunkId) + "." + {"chat":"7ebbd953","chunk-0070e25c":"43ffe4f2","chunk-0736488d":"59576801","chunk-0d12c1d0":"f24a80b7","chunk-157c2bc2":"b116d296","gf":"a118d9d8","chunk-1e90651e":"1a19b5ee","chunk-217be9fa":"4eed72a2","admin":"e3b16e98","aliBey":"c26e6c4d","chunk-0e716554":"ed9b46ea","chunk-24f244bc":"c5a53b01","chunk-2c739c26":"404a49b3","habit~nutrition":"a49035e6","nutrition":"2a70bc72","chunk-502b709f":"7392afc2","chunk-52c1e487":"5b574f6b","HomeNew.vue":"de1463c3","chunk-59c5246e":"63823b8e","workouts":"803e1d47","chunk-515fb775":"7927bbdf","chunk-3678d34d":"4cf0cb7e","dashboard":"b8f19957","chunk-cbcbb77e":"5fb5f42f","chunk-823e23ee":"133b6640","user":"09a14fce","chunk-932f4228":"f9c04faf","chunk-b067410a":"66428175","chunk-e155fa78":"0455c43b","chunk-0a29cabe":"ac2530b4","chunk-21d3ebce":"72ac8eae","chunk-ef2249dc":"ee644ffb","einmalig":"5c026009","habit":"a663d4f2","chunk-3ce22e36":"63dfa427","chunk-10c6d65a":"e91db2d8","chunk-855a8646":"bc4c3f0b","chunk-2d0ae56b":"edde2c1e","chunk-2d0bff72":"8b566eb2","chunk-2d0c8467":"a0cf1a9e","chunk-2d0dda10":"74f52b95","chunk-2d216257":"58872a85","chunk-2d0aa74a":"9fed7d61","chunk-2d225092":"982dca9a","chunk-2f38ff89":"53dbf7aa","chunk-45c97c5e":"531dc46d","chunk-4f70ea14":"77c9d6ea","chunk-d8cd5244":"d9f72473","chunk-16d05c62":"d4e5800e","social":"9ffb2add","deviceManagement":"13109aa6","event":"d9bb27ee","chunk-6f66eaa9":"82d79dee","chunk-b0b127e4":"5e35df55","chunk-b6599cc6":"824e68c7","chunk-23bef907":"1ca97df4","shop":"c602f67e","chunk-cf55ebbe":"6c538426","friends":"a98fced8","payment":"84516808","redirection":"e8d58fad","chunk-015a5b70":"addfe410","chunk-2d216214":"1cff4ebd","chunk-98d9929e":"3f2e9bfa"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chat":1,"chunk-0070e25c":1,"chunk-0736488d":1,"chunk-0d12c1d0":1,"gf":1,"chunk-1e90651e":1,"chunk-217be9fa":1,"admin":1,"aliBey":1,"chunk-0e716554":1,"chunk-24f244bc":1,"chunk-2c739c26":1,"habit~nutrition":1,"nutrition":1,"chunk-502b709f":1,"chunk-52c1e487":1,"HomeNew.vue":1,"chunk-59c5246e":1,"workouts":1,"chunk-515fb775":1,"chunk-3678d34d":1,"dashboard":1,"chunk-cbcbb77e":1,"chunk-823e23ee":1,"user":1,"chunk-932f4228":1,"chunk-b067410a":1,"chunk-e155fa78":1,"chunk-0a29cabe":1,"chunk-21d3ebce":1,"chunk-ef2249dc":1,"einmalig":1,"habit":1,"chunk-3ce22e36":1,"chunk-10c6d65a":1,"chunk-855a8646":1,"chunk-2f38ff89":1,"chunk-45c97c5e":1,"chunk-4f70ea14":1,"chunk-16d05c62":1,"social":1,"deviceManagement":1,"event":1,"chunk-6f66eaa9":1,"chunk-b0b127e4":1,"chunk-b6599cc6":1,"shop":1,"chunk-cf55ebbe":1,"friends":1,"chunk-015a5b70":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chat":"chat","gf":"gf","admin":"admin","aliBey":"aliBey","habit~nutrition":"habit~nutrition","nutrition":"nutrition","HomeNew.vue":"HomeNew.vue","workouts":"workouts","dashboard":"dashboard","user":"user","einmalig":"einmalig","habit":"habit","social":"social","deviceManagement":"deviceManagement","event":"event","shop":"shop","friends":"friends","payment":"payment","redirection":"redirection"}[chunkId]||chunkId) + "." + {"chat":"d1160ddf","chunk-0070e25c":"b7673d55","chunk-0736488d":"51a36163","chunk-0d12c1d0":"62b6bdb5","chunk-157c2bc2":"31d6cfe0","gf":"c9855acb","chunk-1e90651e":"f95702ee","chunk-217be9fa":"fd8c3217","admin":"307e0c62","aliBey":"26b8b2ea","chunk-0e716554":"4e9da95e","chunk-24f244bc":"dee56bdd","chunk-2c739c26":"e8933506","habit~nutrition":"551557c5","nutrition":"7d5e1320","chunk-502b709f":"58bd2dfb","chunk-52c1e487":"63b86e6c","HomeNew.vue":"1a7a95b5","chunk-59c5246e":"0259284e","workouts":"cbdb043a","chunk-515fb775":"aa93e336","chunk-3678d34d":"e089980c","dashboard":"38de9675","chunk-cbcbb77e":"3aae6cf4","chunk-823e23ee":"6030a1c7","user":"81012739","chunk-932f4228":"6742de6e","chunk-b067410a":"b4b6f499","chunk-e155fa78":"a498c039","chunk-0a29cabe":"aa93e336","chunk-21d3ebce":"f86c39fd","chunk-ef2249dc":"38cdad1c","einmalig":"fa492b35","habit":"346ce143","chunk-3ce22e36":"b8702556","chunk-10c6d65a":"0d4ad401","chunk-855a8646":"df716a94","chunk-2d0ae56b":"31d6cfe0","chunk-2d0bff72":"31d6cfe0","chunk-2d0c8467":"31d6cfe0","chunk-2d0dda10":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-2d0aa74a":"31d6cfe0","chunk-2d225092":"31d6cfe0","chunk-2f38ff89":"6d2549ac","chunk-45c97c5e":"e9b57efc","chunk-4f70ea14":"e234d813","chunk-d8cd5244":"31d6cfe0","chunk-16d05c62":"9d5e1cc3","social":"38002047","deviceManagement":"a40c19d5","event":"d8b22b17","chunk-6f66eaa9":"840f11ef","chunk-b0b127e4":"7de921b1","chunk-b6599cc6":"b71a634a","chunk-23bef907":"31d6cfe0","shop":"1674ba39","chunk-cf55ebbe":"8b18ed18","friends":"52064fe5","payment":"31d6cfe0","redirection":"31d6cfe0","chunk-015a5b70":"0319f6a0","chunk-2d216214":"31d6cfe0","chunk-98d9929e":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
